"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootUnsubscribeSagas = void 0;
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var UnsubscribeAction_1 = require("@/pages/unsubscribe/actions/UnsubscribeAction");
var effects_1 = require("redux-saga/effects");
var SaveSearchApiSaga_1 = require("@/pages/search/sagas/api/SaveSearchApiSaga");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var deleteUser_1 = require("@/pages/accountInfo/sagas/api/deleteUser");
var WindowApi_1 = require("@/api/browser/WindowApi");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var getIsUnsubscribeAll = function (state) { return __spreadArrays([state.unsubscribe.newsletterChecked], state.unsubscribe.savedSearchesSearchSets.map(function (it) { return it.notificationEnabled; }), state.unsubscribe.followingsSearchSets.map(function (it) { return it.notificationEnabled; })).filter(function (it) { return it === true; }).length === 0; };
var getDownloadDataChecked = function (state) { return state.unsubscribe.downloadDataChecked; };
var unsubscribeAll = function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.unsubscribeApi)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response && response.data.result.status === 2];
        }
    });
};
var unsubscriptionUpdateSuccess = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized(BigPopupState_1.BigPopupType.SUCCESS, 'success', 'unsubscribeSuccess'))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var unsubscriptionUpdateFailed = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized(BigPopupState_1.BigPopupType.FAILED, 'failed', 'unsubscribeFailed'))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var getSearchSets = function (state) {
    return state.unsubscribe.savedSearchesSearchSets.concat(state.unsubscribe.followingsSearchSets);
};
var getNewsletterChecked = function (state) {
    return state.unsubscribe.newsletterChecked;
};
var updateSearchSets = function (searchSets) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.saveSearchSetsApi, searchSets)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response && response.data.result.status === 2];
        }
    });
};
var updateNewsletter = function (newsletterChecked) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.setUserSubscribeApi, newsletterChecked)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response && response.data.result.status === 2];
        }
    });
};
var onSaveClicked = function () {
    var isUnsubscribeAll, status, searchSets, newsletterChecked;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.take(UnsubscribeAction_1.default.UNSUBSCRIBE_ON_SAVE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsUnsubscribeAll)];
            case 2:
                isUnsubscribeAll = _a.sent();
                status = false;
                return [4 /*yield*/, effects_1.put(UnsubscribeAction_1.default.setIsLoading(true))];
            case 3:
                _a.sent();
                if (!isUnsubscribeAll) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(unsubscribeAll)];
            case 4:
                status = _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, effects_1.select(getSearchSets)];
            case 6:
                searchSets = _a.sent();
                return [4 /*yield*/, effects_1.call(updateSearchSets, searchSets)];
            case 7:
                status = _a.sent();
                return [4 /*yield*/, effects_1.select(getNewsletterChecked)];
            case 8:
                newsletterChecked = _a.sent();
                return [4 /*yield*/, effects_1.call(updateNewsletter, newsletterChecked)];
            case 9:
                status = _a.sent();
                return [4 /*yield*/, effects_1.put(UnsubscribeAction_1.default.setIsLoading(false))];
            case 10:
                _a.sent();
                if (!status) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.call(unsubscriptionUpdateSuccess)];
            case 11:
                _a.sent();
                return [3 /*break*/, 14];
            case 12: return [4 /*yield*/, effects_1.call(unsubscriptionUpdateFailed)];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [3 /*break*/, 0];
            case 15: return [2 /*return*/];
        }
    });
};
var onDeleteUnsubscribeClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(UnsubscribeAction_1.default.UNSUBSCRIBE_ON_DELETE_UNSUBSCRIBE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(UnsubscribeAction_1.default.onDeleteCloseClicked())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(UnsubscribeAction_1.default.onAllNotificationChanged(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(UnsubscribeAction_1.default.onSaveClicked())];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var deleteUserSuccess = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized(BigPopupState_1.BigPopupType.SUCCESS, 'success', 'deleteUserSuccess'))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var deleteUserFailed = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized(BigPopupState_1.BigPopupType.SUCCESS, 'success', 'deleteUserSuccess'))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var downloadDataPopup = function () {
    var langCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                langCode = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.windowOpen, "/" + langCode + "/profile/downloaduserdata")];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var deleteUserCall = function (requestDownload) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!requestDownload) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.call(downloadDataPopup)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, effects_1.call(deleteUser_1.deleteUser)];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response.isDeleted];
        }
    });
};
var onDeleteClicked = function () {
    var downloadDataChecked, status;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(UnsubscribeAction_1.default.UNSUBSCRIBE_ON_CONFIRM_DELETE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getDownloadDataChecked)];
            case 2:
                downloadDataChecked = _a.sent();
                return [4 /*yield*/, effects_1.put(UnsubscribeAction_1.default.setIsLoading(true))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(deleteUserCall, downloadDataChecked)];
            case 4:
                status = _a.sent();
                return [4 /*yield*/, effects_1.put(UnsubscribeAction_1.default.setIsLoading(false))];
            case 5:
                _a.sent();
                if (!status) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.call(deleteUserSuccess)];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(3000)];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, '/')];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, effects_1.call(deleteUserFailed)];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var onLogout = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_LOGOUT_SUCCESS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, '/')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var rootUnsubscribeSagas = {
    onSaveClicked: onSaveClicked,
    onDeleteUnsubscribeClicked: onDeleteUnsubscribeClicked,
    onDeleteClicked: onDeleteClicked,
    onLogout: onLogout,
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
};
exports.rootUnsubscribeSagas = rootUnsubscribeSagas;
